<script lang="ts">
    
    import { Table } from "sveltestrap";
    import type { QuestionGridColumnType, QuestionOptionsObject } from "../global";
    import type { QuestionGrid } from "../Model/QuestionGrid";
    import Editable from "./FormPreview/Editable.svelte";
    import Watch from "./Watch.svelte";

    const typesMap = {
        text    : 'Texto',
        date    : 'Fecha',
        amount  : 'Cantidad',
        check   : 'Check'
    };

    export let options: QuestionOptionsObject;
    
    let grid: QuestionGrid;

    $: if (options) {
        grid = options.questionGrid;
    }

    function typeName(type: QuestionGridColumnType): string {
        return typesMap[type] || '';
    }

</script>

{#if grid}
<Table bordered>
    <thead>
        <tr>
            <th></th>
            <Watch store={grid.columns} let:value={columns}>
                {#each columns as column}
                    <th>
                        <i class="text-secondary">
                            <Editable store={column.name} />
                        </i>
                    </th>
                {/each}
            </Watch>
        </tr>
    </thead>
    <tbody>
        <Watch store={grid.rows} let:value={rows}>
            {#each rows as row}
                <tr>
                    <td>
                        <Editable store={row.text} />
                    </td>
                    <Watch store={grid.columns} let:value={columns}>
                        {#each columns as column}
                            <td>
                                <i class="text-secondary">
                                    (
                                        <Watch store={column.type} let:value>{typeName(value)}</Watch>
                                        <Watch store={column.required} let:value>{value ? '*' : ''}</Watch>
                                    )
                                </i>
                            </td>
                        {/each}
                    </Watch>
                </tr>
            {/each}
        </Watch>
    </tbody>
</Table>
{/if}
